import { ApiError } from '@gorila-shared-ui/components';
import { ApiEndpoint } from '../types/api';
import { AvailableCommand, CommandCategory, DeviceCommands } from '../types/availableCommand';
import { Command } from '../types/command';
import { getRequest, postRequest } from './api';
import { availableCommandsUrl, commandListUrl, commandsUrl } from './urls/commandUrl';

export const getCommands = async (
  page: number,
  clientId: string,
  subClientId?: string,
  assetId?: string,
  status?: string,
  commandType?: string
): Promise<{ commands?: Command[]; error?: ApiError; total?: number }> => {
  const params: { [key: string]: string } = {};
  if (assetId) params['assetId'] = assetId;
  if (status) params['status'] = status;
  if (commandType) params['commandType'] = commandType;
  const response = await getRequest(
    commandsUrl,
    {
      queryParams: { clientId, subClientId, page, ...params },
    },
    undefined,
    ApiEndpoint.core
  );
  return {
    total: response?.data?.total,
    commands: response?.data?.items,
    error: response?.error,
  };
};

export const getCommandList = async (
  clientId: string,
  subClientId: string
): Promise<{ availableCommands?: AvailableCommand[]; error?: ApiError }> => {
  const response = await getRequest(
    commandListUrl,
    {
      queryParams: { clientId, subClientId },
    },
    undefined,
    ApiEndpoint.core
  );
  return {
    availableCommands: response?.data?.commands,
    error: response?.error,
  };
};

export const getAvailableCommands = async (
  assetId: string,
  commandCategory?: CommandCategory
): Promise<{ devices?: DeviceCommands[]; error?: ApiError }> => {
  const response = await getRequest(
    availableCommandsUrl(assetId), 
    { queryParams: { commandCategory } }, 
    undefined, 
    ApiEndpoint.core
  );
  return {
    devices: response?.data?.devices,
    error: response?.error,
  };
};

export const postCommand = async (
  assetId: string,
  clientId: string,
  subClientId: string,
  command: string,
  ident: string,
  subAccountId?: string,
  fields?: { [key: string]: string | number }
): Promise<{ commandId?: string; error?: ApiError }> => {
  const response = await postRequest(
    commandsUrl,
    {
      body: {
        clientId,
        subClientId,
        assetId,
        command,
        ident,
        subAccountId,
        fields,
      },
    },
    ApiEndpoint.core
  );

  return {
    commandId: response?.data?.commandId,
    error: response?.error,
  };
};
